import { render, staticRenderFns } from "./electronicsRight.vue?vue&type=template&id=f63be490&scoped=true&"
import script from "./electronicsRight.vue?vue&type=script&lang=js&"
export * from "./electronicsRight.vue?vue&type=script&lang=js&"
import style0 from "./electronicsRight.vue?vue&type=style&index=0&id=f63be490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63be490",
  null
  
)

export default component.exports